import { TTF_URLS } from "./fontUrls";
import type { PageSpec } from "./ir";
import { layoutDocument } from "./layout";
import type { PdfMeta } from "./renderPdf";

// Builds a resume PDF in the browser: the same off-screen layout and page
// split as the live preview (layout.tsx), then react-pdf (loaded on demand)
// draws those exact pages.

export async function exportPdf(spec: PageSpec, meta: PdfMeta): Promise<{ blob: Blob; pageCount: number }> {
  const { doc, texts } = await layoutDocument(spec);
  const { renderPdfBlob } = await import("./renderPdf");
  const blob = await renderPdfBlob(doc, texts, meta, (stem) => TTF_URLS[stem]);
  return { blob, pageCount: doc.pages.length };
}

/** Saves [blob] as a download named [fileName]. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
